import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2ba37b05"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-calendar me-2" }, null, -1))
const _hoisted_2 = { class: "sticky" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-1" }
const _hoisted_4 = { class: "btn-group" }
const _hoisted_5 = {
  key: 0,
  class: "btn btn-outline-secondary btn-sm dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-cog me-2" }, null, -1))
const _hoisted_7 = { class: "dropdown-menu" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-edit me-2" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt me-2" }, null, -1))
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-clock me-2" }, null, -1))
const _hoisted_12 = { class: "text-muted" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-calendar-day me-2" }, null, -1))
const _hoisted_15 = { class: "text-muted" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-map-marker-alt me-2" }, null, -1))
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-info-circle me-2" }, null, -1))
const _hoisted_20 = { class: "text-muted" }
const _hoisted_21 = { class: "d-flex justify-content-center" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-search me-2" }, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-mail-bulk me-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseOffcanvasComponent = _resolveComponent("BaseOffcanvasComponent")!
  const _component_ActivityMessageComponent = _resolveComponent("ActivityMessageComponent")!
  const _directive_dompurify_html = _resolveDirective("dompurify-html")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseOffcanvasComponent, {
      ref: "activityOffcanvas",
      placement: "right",
      onHidden: _ctx.handleHidden
    }, {
      title: _withCtx(() => [
        _hoisted_1,
        _createTextVNode("การปฏิบัติราชการในภูมิภาค ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.isOrs)
                ? (_openBlock(), _createElementBlock("button", _hoisted_5, [
                    _hoisted_6,
                    _createTextVNode("แก้ไข ")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("ul", _hoisted_7, [
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editClick && _ctx.editClick(...args)))
                  }, [
                    _hoisted_8,
                    _createTextVNode("แก้ไขข้อมูล ")
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("button", {
                    class: "dropdown-item",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
                  }, [
                    _hoisted_9,
                    _createTextVNode("ลบ ")
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode("วันที่: "),
          _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.activity?.startDate.toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })) + " - " + _toDisplayString(_ctx.activity?.endDate.toLocaleDateString('th-TH', { year: 'numeric', month: 'long', day: 'numeric' })), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createTextVNode("เรื่อง: "),
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.activity?.name), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createTextVNode("สถานที่: "),
          _createElementVNode("p", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity?.provinces, (province) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "badge bg-primary rounded-pill me-1 mt-1",
                key: province.id
              }, _toDisplayString(province.name), 1))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createTextVNode("รายละเอียด: "),
          _withDirectives(_createElementVNode("p", _hoisted_20, null, 512), [
            [_directive_dompurify_html, _ctx.activity?.description ? _ctx.activity?.description.replace(/(?:\r\n|\r|\n)/g, '<br />') : '-']
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          (_ctx.isOrs)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-success",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.detailClick && _ctx.detailClick(...args)))
              }, [
                _hoisted_22,
                _createTextVNode("ผลการปฏิบัติราชการ ")
              ]))
            : _createCommentVNode("", true),
          (_ctx.isOrs && !_ctx.activity?.hasMessage)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: "btn btn-secondary ms-2",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.messageClick && _ctx.messageClick(...args)))
              }, [
                _hoisted_23,
                _createTextVNode("ส่งข้อความถึงผู้เกี่ยวข้อง ")
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["onHidden"]),
    _createVNode(_component_ActivityMessageComponent, {
      ref: "activityMessageModal",
      "activity-id": _ctx.activityId
    }, null, 8, ["activity-id"])
  ], 64))
}